import BaseApi from './base';

class Event extends BaseApi {
    endpoint = 'events';
}

export default new Event();




// WEBPACK FOOTER //
// ./src/psuite-js/apis/delivery/event.js